const Footer = ()=>{

return(
<footer className="footer">
  <div className="footer-top-gradient"></div>

  <div className="footer-content">
    {/* <!-- Logo & Motto --> */}
    <div className="footer-brand">
      <img src="http://file.fountainafrica.org/wp-content/uploads/2025/11/FAT%20Logo.jpg" alt="Fountain Africa Trust Logo" className="footer-logo" />
      <h2>Fountain Africa Trust</h2>
      <p className="tagline">Empowering communities for sustainable change.</p>
      <div className="social-icons">
        <a href="#"><i className="fab fa-facebook-f"></i></a>
        <a href="#"><i className="fab fa-twitter"></i></a>
        <a href="#"><i className="fab fa-linkedin-in"></i></a>
        <a href="#"><i className="fab fa-instagram"></i></a>
        <a href="#"><i className="fab fa-youtube"></i></a>
      </div>
    </div>

    {/* <!-- Quick Links --> */}
    <div className="footer-section">
      <h3>Quick Links</h3>
      <ul>
      <li><a href="/">Home</a></li>
        <li><a href="#">Careers</a></li>
        <li><a href="#">Partnerships</a></li>
        <li><a href="/staff" target="_blank" rel="noopener noreferrer">Staff Portal</a></li>
        <li><a href="https://mbox.fountainafrica.org/" target="_blank" rel="noopener noreferrer">Staff Email</a></li>
      </ul>
      <h3>Get Involved</h3>
      <ul>
        <li><a href="/getinvolved/#donate">Donate</a></li>
        <li><a href="/getinvolved/#volunteer">Volunteer</a></li>
        <li><a href="#">Careers</a></li>
        <li><a href="#">Partnerships</a></li>
      </ul>
    </div>

    {/* <!-- Who We Are --> */}
    <div className="footer-section">
      <h3>Who We Are</h3>
      <ul>
        <li><a href="/who-we-are#about-us">About Us</a></li>
        <li><a href="/who-we-are#our-mission">Mission & Vision</a></li>
        <li><a href="/projects">Programs & Projects</a></li>
        <li><a href="/who-we-are#our-leadership">Leadership & Partners</a></li>
      </ul>
    </div>

    {/* <!-- Get Involved --> */}
    {/* <div className="footer-section"> */}
      {/* <h3>Get Involved</h3>
      <ul>
        <li><a href="#">Donate</a></li>
        <li><a href="#">Volunteer</a></li>
        <li><a href="#">Careers</a></li>
        <li><a href="#">Partnerships</a></li>
      </ul> */}
    {/* </div> */}

    {/* <!-- Resources --> */}
    <div className="footer-section">
      <h3>Resources</h3>
      <ul>
        <li><a href="#">Annual Reports</a></li>
        <li><a href="#">Publications & Media</a></li>
        <li><a href="#">Transparency</a></li>
        <li><a href="#">Procurement</a></li>
      </ul>
    </div>
    {/* <!-- Contact --> */}
    <div className="footer-section">
      <h3>Contact Us</h3>
      <p>Fountain Africa Trust </p>
      <p>Physical address: T-Junction, </p>
      <p>Webuye – Kitale Road</p>
      <p>Lugonzo Estate House No. 4 </p>
      <p>Webuye Town Bungoma County (Kenya)</p>
      <p>P.O. Box 1632 50205</p>
      <p> Webuye</p>
      <p>www.fountainafrica.org</p>
      <p>📞 +254 731 441 220</p>
      <p>📞 +254 720 441 220</p>
      <p> ✉️ info@fountainafricatrust.org </p>
    </div>

  </div>

  <div className="footer-bottom">
    <p>© 2025 Fountain Africa Trust. All rights reserved.</p>
  </div>
</footer>)
}


export default Footer
